import _ from 'lodash';

/**
 * Checks the difference between queries
 */
export const checkDifference = ({
  query1,
  query2,
  exclude = [],
}: {
  query1: object;
  query2: object | undefined;
  exclude: string[];
}) => {
  if (!query1 || !query2) {
    return [];
  }

  query1 = getClassProperties(query1, exclude);
  query2 = getClassProperties(query2, exclude);

  return getMismatchedKeys(query1, query2, exclude);
};

const getMismatchedKeys = (query1: object, query2: object, _exclude: string[] = []) => {
  const mismatches: string[] = [];

  // Iterate over the keys in query1
  _.forEach(query1, (value, key) => {
    const equal = _.isEqualWith(value, query2[key as keyof typeof query1], (a, b) => {
      if (Array.isArray(a) && Array.isArray(b)) {
        return _.isEqual(_.sortBy(a), _.sortBy(b));
      }
      return undefined;
    });

    if (!equal) {
      mismatches.push(key);
    }
  });

  // Check for keys in query2 that are not in query1
  _.forEach(query2, (_value, key) => {
    if (!_.has(query1, key)) {
      mismatches.push(key);
    }
  });

  return mismatches;
};

const getClassProperties = (instance: object, exclude: string[]): Record<string, unknown> => {
  return Object.fromEntries(
    Object.entries(instance).filter(([key, value]) => typeof value !== 'function' && !exclude.includes(key)),
  );
};
